import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import {
  type HomeSectionName,
  useActiveSectionContext,
} from '@/store/context/active-section';

/**
 *
 * - https://codesandbox.io/p/devbox/vigilant-bouman-dmktm3?file=%2Fcomponents%2Fcontact.tsx
 *
 * @param {HomeSectionName} sectionName
 * @param {number} threshold
 * @returns {{ref: (node?: (Element | null)) => void}}
 */
export function useSectionInView(
  sectionName: HomeSectionName,
  threshold = 0.75,
) {
  const { ref, inView } = useInView({
    threshold,
  });
  const { setActiveSection, timeOfLastClick } = useActiveSectionContext();

  useEffect(() => {
    if (inView && Date.now() - timeOfLastClick > 1000) {
      setActiveSection(sectionName);
    }
  }, [inView, setActiveSection, timeOfLastClick, sectionName]);

  return {
    ref,
  };
}
